import React from 'react'
import { Accordion, AccordionDetails } from '@mui/material'
import { Photos, Videos, Panoramas, Description, WalkingPhotos } from '.'
import { useMediaDetails } from 'Hooks/useMediaDetails'
import { getWalkingPoints } from 'Hooks/getWalkingPoints'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { AccordionHeading } from 'Components/accordionHeading'

interface SupplementalMediaProps {
  stopId?: number
  mainMediaId?: number
}

const SupplementalMedia = ({ stopId, mainMediaId }: SupplementalMediaProps) => {
  const {
    photos,
    photoAssetUrl,
    videos,
    panoramas,
    panoAssetUrl,
    photoHotspots,
    videoHotspots,
    panoHotspots,
    textHotspots,
    photoPosMedia,
    videoPosMedia,
    panoPosMedia,
  } = useMediaDetails(stopId)

  const { walkingPoints } = getWalkingPoints(stopId)

  const combinedPhotos =
    photos && photoHotspots && photoPosMedia
      ? [...photos, ...photoHotspots, ...photoPosMedia]
      : []
  const combinedVideos =
    videos && videoHotspots && videoPosMedia
      ? [...videos, ...videoHotspots, ...videoPosMedia]
      : []
  const combinedPanoramas =
    panoramas && panoHotspots && panoPosMedia
      ? [...panoramas, ...panoHotspots, ...panoPosMedia]
      : []

  const filteredPanoramas = mainMediaId
    ? combinedPanoramas.filter((item: any) => item.id !== mainMediaId)
    : combinedPanoramas

  const filteredPhotos = mainMediaId
    ? combinedPhotos.filter((item: any) => item.photoid !== mainMediaId)
    : combinedPhotos

  return (
    <>
      {filteredPhotos.length > 0 && (
        <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
          <AccordionHeading level={3} expandIcon={<ExpandMoreIcon />}>
            Photos
          </AccordionHeading>
          <AccordionDetails>
            <Photos photos={filteredPhotos} assetUrl={photoAssetUrl} />
          </AccordionDetails>
        </Accordion>
      )}

      {combinedVideos.length > 0 && (
        <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
          <AccordionHeading level={3} expandIcon={<ExpandMoreIcon />}>
            Videos
          </AccordionHeading>
          <AccordionDetails>
            <Videos videos={combinedVideos} />
          </AccordionDetails>
        </Accordion>
      )}

      {filteredPanoramas.length > 0 && (
        <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
          <AccordionHeading level={3} expandIcon={<ExpandMoreIcon />}>
            Panoramas
          </AccordionHeading>
          <AccordionDetails>
            <Panoramas panoramas={filteredPanoramas} assetUrl={panoAssetUrl} />
          </AccordionDetails>
        </Accordion>
      )}

      {textHotspots?.length > 0 && (
        <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
          <AccordionHeading level={3} expandIcon={<ExpandMoreIcon />}>
            Descriptions
          </AccordionHeading>
          <AccordionDetails>
            <Description hotspots={textHotspots} />
          </AccordionDetails>
        </Accordion>
      )}

      {walkingPoints.stopPoints.length > 0 && (
        <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
          <AccordionHeading level={3} expandIcon={<ExpandMoreIcon />}>
            Walking Points
          </AccordionHeading>
          <AccordionDetails>
            <p>You are now walking to the next stop experience.</p>
            <WalkingPhotos
              walkingPoints={walkingPoints}
              assetUrl={photoAssetUrl}
            />
          </AccordionDetails>
        </Accordion>
      )}
    </>
  )
}

export default SupplementalMedia
